// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiNotification } from '../models/ApiNotification';
import { HttpFile } from '../http/http';

export class ApiNotificationsResponse {
    'notifications': Array<ApiNotification>;
    'unread_count': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "notifications",
            "baseName": "notifications",
            "type": "Array<ApiNotification>",
            "format": ""
        },
        {
            "name": "unread_count",
            "baseName": "unread_count",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiNotificationsResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

